import * as angular from 'angular';
import * as $ from 'jquery';
import * as _ from 'lodash';

import { IDashboardService, IwidgetService, ILoggerService } from '../../../services/';
import { Dashboard, ComponentDefinition, Group } from '../../../models/';
import { IWidget, IdataWidget } from '../../../widgets';

interface FormController extends angular.IFormController {
    newName: angular.INgModelController;
}

class DuplicateWidgetModalController implements angular.IComponentController {
    canRename: boolean;
    dashboardGuid: string;
    dashboards: Dashboard[];
    dashboardsList: { key: string, value: string }[];
    destination: 'dashboard' | 'validationPage';
    formCtrl: FormController;
    groupsRename: { oldValue: string, newValue: string }[];
    isLoading: boolean;
    loadingMessage: string;
    newName: string;
    seriesRename: { oldValue: string, newValue: string }[];
    targetGuid: string;
    widget: IWidget;
    widgets: { guid: string; name: string; }[];

    readonly addToValidationPage: (value: { groupGuid: string; widget: IWidget }) => angular.IPromise<any>;
    readonly initialGroup: Group;
    readonly isInputWidget: boolean;
    readonly validationPageGroups: Group[];

    private _garbages: (() => void)[] = [];
    private _modalName = 'duplicateWidgetModal';
    private _widgets: { [dashboardGuid: string]: IWidget[] };

    onDuplicated: (dashboard: any) => void;

    static $inject = [
        'dashboardService',
        'loggerService',
        'widgetService'
    ];
    constructor(
        private _dashboardService: IDashboardService,
        private _loggerService: ILoggerService,
        private _widgetService: IwidgetService
    ) {
    }

    $onInit() {
        this.seriesRename = [];
        this.groupsRename = [];
        $(`#${this._modalName}`).on('hidden.bs.modal', () => {
            this.cleanForm();
        });

        this.initDashboards();
        this.destination = 'dashboard';
    }

    $onDestroy() {
        this._garbages.forEach(g => g());
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['dashboardGuid']) {
            if (changesObj['dashboardGuid'].currentValue) {
                this.setCurrent(changesObj['dashboardGuid'].currentValue);
            }
        }

        if (changesObj['dashboards']) {
            this.initDashboards();
        }

        if (changesObj['isInputWidget'] || changesObj['initialGroup'] || changesObj['validationPageGroups']) {
            this.setInitialSelection();
        }

        if (changesObj['widget']) {
            this.newName = this.widget?.name;
        }
    }

    private initDashboards() {
        this._widgets = {};

        if (this.dashboards) {
            this.dashboards.forEach(d => {
                this._widgets[d.guid] = d.configuration.widgets;
            });
            this.dashboardsList = _.sortBy(
                this.dashboards.map(d => { return { key: d.guid, value: d.name }; }),
                d => d.value
            );
            this.setCurrent(this.dashboardGuid);
        }
    }

    update() {
        this.isLoading = true;
        const seriesRename = this.destination === 'dashboard'
            ? this.seriesRename
            : [];
        const groupsRename = this.destination === 'dashboard'
            ? this.groupsRename
            : [];
        this._widgetService
            .cloneWidget(this.widget, this.newName, seriesRename, groupsRename)
            .then(data => {
                const { copy, mappings } = data;
                let promise: angular.IPromise<void>;
                if (this.destination === 'dashboard') {
                    promise = this.addToDashboard(copy);
                } else {
                    if (!this.addToValidationPage) {
                        return;
                    }
                    else {
                        promise = this.addToValidationPage({ groupGuid: this.targetGuid, widget: copy });
                    }
                }
                return promise
                    .then(() => {
                        this._loggerService.logSuccess('Successfully duplicated widget');
                        if (mappings.irreplacible && mappings.irreplacible.length) {
                            mappings.irreplacible
                                .forEach(mapping => {
                                    this._loggerService.logWarning(`Series ${mapping.newVm.name} does not exist, series ${mapping.originalVm.name} kept in place in widget ${this.newName}.`);
                                });
                        }
                        $(`#${this._modalName}`).modal('hide');
                        this.cleanForm();
                    });
            })
            .catch(e => console.error(e))
            .finally(() => this.isLoading = false);
    }

    private addToDashboard(copy: any) {
        return this._dashboardService.addWidget(this.targetGuid, copy)
            .then(data => {
                this._widgets[data.guid] = data.configuration.widgets;
                if (this.onDuplicated) {
                    this.onDuplicated({ dashboard: data });
                }
            });
    }


    validateName() {
        const newValue = this.formCtrl.newName.$viewValue?.toLowerCase();
        const isValid = !_.some(this.widgets, t => t.name.toLowerCase() === newValue);
        this.formCtrl.newName.$setValidity('duplicate', isValid);
    }

    private cleanForm() {
        this.groupsRename = [];
        this.seriesRename = [];
        this.newName = null;
        this.formCtrl.$setPristine();
        this.setInitialSelection();
    }

    private setInitialSelection() {
        if (this.isInputWidget) {
            this.destination = 'validationPage';
        }
        else if (this.validationPageGroups?.map(d => d.guid).includes(this.initialGroup?.guid)) {
            this.destination = 'validationPage';
            this.targetGuid = this.initialGroup?.guid;
        }
        else {
            this.destination = 'dashboard';
        }
    }

    onDashboardChange() {
        this.setCurrent(this.targetGuid);
        this.validateName();
    }

    private setCurrent(guid: string) {
        if (guid) {
            this.targetGuid = guid;
        }
    }
}

export const wtDuplicateWidgetModal: ComponentDefinition = {
    componentId: 'wtDuplicateWidgetModal',
    controller: DuplicateWidgetModalController,
    template: require('./duplicateWidgetModal.component.html'),
    controllerAs: 'vm',
    bindings: {
        addToValidationPage: '&?',
        canRename: '<',
        dashboardGuid: '<',
        dashboards: '<',
        initialGroup: '<?',
        isInputWidget: '<?',
        onDuplicated: '&?',
        validationPageGroups: '<',
        widget: '<'
    }
};